// extracted by mini-css-extract-plugin
module.exports = {"active":"Game_active__fJn32","active_button":"Game_active_button__ki0cK","cardImage":"Game_cardImage__6VtHl","card-width":"Game_card-width__vfvzT"};